module.exports = __webpack_public_path__ + "img/KD.95d58638.svg";